<header class="row header sticky-top m-0 shadow-sm">
    <div class="col-md-6">
        <div class="row pl-3">
            <button type="button" class="btn mx-1 my-1" (click)="toggleSidebar()"><i class="fa fa-bars fa-lg"
                    aria-hidden="true"></i></button>
            <div class="pt-1">
                <h5 class="mt-2">{{currentPath}}</h5>
            </div>
        </div>
    </div>
    <!-- <div class="col-md-6 text-right pt-1">
        <i class="fa fa-2x fa-user-circle-o mt-2" aria-hidden="true" [title]="currentUser"></i>
    </div> -->
</header>